import {
  type GenerateStyle,
  type FullToken,
  genComponentStyleHook,
} from "antd/es/theme/internal";
import { buttonPrefixCls } from "@/base/components/button/Button.component";
import { THEME_PREFIX, ICON_PREFIX } from "@/base/constant";

const genStyle: GenerateStyle<FullToken<"Button">> = (token: any) => {
  const {
    colorSuccess,
    colorSuccessHover,
    colorSuccessBgHover,
    colorSuccessText,
    colorErrorBgHover,
    colorErrorText,
    colorPrimaryBgHover,
    colorPrimaryText,
    onlyIconSize,
    onlyIconSizeLG,
    onlyIconSizeSM,
    contentFontWeight,
    contentFontWeightLG,
    contentFontWeightSM,
  } = token;
  return {
    [`.${THEME_PREFIX}`]: {
      [`&.${buttonPrefixCls}`]: {
        fontWeight: contentFontWeight,
        [`&.${buttonPrefixCls}-loading`]: {
          opacity: 1,
        },
        [`&.${buttonPrefixCls}-lg`]: {
          fontWeight: contentFontWeightLG,
          [`.${buttonPrefixCls}-icon, .${ICON_PREFIX}`]: {
            fontSize: onlyIconSizeLG,
          },
        },
        [`&.${buttonPrefixCls}-sm`]: {
          fontWeight: contentFontWeightSM,
          [`.${buttonPrefixCls}-icon, .${ICON_PREFIX}`]: {
            fontSize: onlyIconSizeSM,
          },
        },
        [`.${buttonPrefixCls}-icon, .${ICON_PREFIX}`]: {
          fontSize: onlyIconSize,
        },
        [`&.${buttonPrefixCls}-variant-solid`]: {
          [`&.${buttonPrefixCls}-color-green`]: {
            background: colorSuccess,
            [`&:not(:disabled):not(.cso-btn-disabled):hover`]: {
              background: colorSuccessHover,
            },
          },
        },
        [`&.${buttonPrefixCls}-variant-outlined`]: {
          [`&:not(:disabled):not(.${buttonPrefixCls}-disabled):not(.${buttonPrefixCls}-loading):hover`]:
            {
              [`&.${buttonPrefixCls}-color-dangerous`]: {
                background: colorErrorBgHover,
                color: colorErrorText,
              },
              [`&.${buttonPrefixCls}-color-default, &.${buttonPrefixCls}-color-primary`]:
                {
                  background: colorPrimaryBgHover,
                  color: colorPrimaryText,
                },
              [`&.${buttonPrefixCls}-color-green`]: {
                background: colorSuccessBgHover,
                color: colorSuccessText,
              },
            },
          [`&.${buttonPrefixCls}-color-green`]: {
            borderColor: colorSuccess,
            color: colorSuccess,
          },
        },
        [`&.${buttonPrefixCls}-variant-link, &.${buttonPrefixCls}-variant-text`]:
          {
            width: "auto",
            padding: 0,
            height: "auto",
            borderRadius: 0,
            gap: "4px",
            borderBottom: "1px solid transparent",

            [`&:hover`]: {
              borderBottomColor: "transparent !important",
            },

            [`.${buttonPrefixCls}-content`]: {
              borderBottom: "1px solid transparent",
              paddingBottom: "2px",
              marginBottom: "-2px",
            },

            [`&:not(:disabled):not(.${buttonPrefixCls}-disabled)`]: {
              backgroundColor: "transparent",

              [`&:not(.${buttonPrefixCls}-loading)`]: {
                [`&.${buttonPrefixCls}-color-dangerous`]: {
                  [`&:hover`]: {
                    backgroundColor: "transparent",
                    color: colorErrorText,
                  },
                },
                [`&.${buttonPrefixCls}-color-default`]: {
                  [`&:hover`]: {
                    backgroundColor: "transparent",
                    color: colorPrimaryText,
                  },
                },
                [`&.${buttonPrefixCls}-color-primary`]: {
                  [`&:hover`]: {
                    backgroundColor: "transparent",
                    color: colorPrimaryText,
                  },
                },
                [`&.${buttonPrefixCls}-color-green`]: {
                  [`&:hover`]: {
                    backgroundColor: "transparent",
                    color: colorSuccessText,
                  },
                },
              },
            },
          },

        [`&.${buttonPrefixCls}-variant-link`]: {
          [`&:not(:disabled):not(.${buttonPrefixCls}-disabled)`]: {
            [`&:not(.${buttonPrefixCls}-loading)`]: {
              [`&.${buttonPrefixCls}-color-dangerous`]: {
                [`&:hover`]: {
                  [`.${buttonPrefixCls}-content`]: {
                    borderBottomColor: colorErrorText,
                  },
                },
              },
              [`&.${buttonPrefixCls}-color-default`]: {
                [`&:hover`]: {
                  [`.${buttonPrefixCls}-content`]: {
                    borderBottomColor: colorPrimaryText,
                  },
                },
              },
              [`&.${buttonPrefixCls}-color-primary`]: {
                [`&:hover`]: {
                  [`.${buttonPrefixCls}-content`]: {
                    borderBottomColor: colorPrimaryText,
                  },
                },
              },
              [`&.${buttonPrefixCls}-color-green`]: {
                [`&:hover`]: {
                  [`.${buttonPrefixCls}-content`]: {
                    borderBottomColor: colorSuccessText,
                  },
                },
              },
            },
          },
        },
      },
    },
  };
};

export const useButtonStyle = genComponentStyleHook(
  ["Button", "cso"],
  (token) => {
    return [genStyle(token)];
  },
);
